// SectionList.js
import React from 'react';
import placeholder_image from "assets/images/info/card-placeholder-medium.png";
import CardCarousel from '../..//components/StoreMenuCardCarousel';
import RankedCarousel from '../..//components/StoreMenuRankedCardCarousel';

const SectionList = ({ column, resolved, imageMap, mode, navigateToUrl }) => {
  if (!resolved?.content || resolved.content.length === 0) return null;

  const isDesktop = mode === 'desktop';
  const isGridType = ["topics", "questionSets"].includes(column.type);
  const isRankType = ["ranking", "qsRanking"].includes(column.type);

  // DESKTOP: grid cards
  if (isDesktop) {
    return (
      <div style={{ padding: "0 40px 40px 40px", background: "#ffffff" }}>
        <div style={{ borderTop: "1px solid #e9ecef", paddingTop: "30px" }} />
        <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 20px" }}>
          <div style={{ marginBottom: 25, textAlign: "center" }}>
            <h3 style={{ margin: "0 0 8px", fontSize: 24, fontWeight: 600, color: "#2c3e50" }}>
              {column.label}
            </h3>
            {column.description && (
              <p style={{ margin: 0, fontSize: 16, color: "#6c757d", maxWidth: 600, marginInline: "auto" }}>
                {column.description}
              </p>
            )}
          </div>

          {isGridType && (
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 24 }}>
              {resolved.content.map((item, idx) => (
                <div
                  key={idx}
                  onClick={() => item.url && navigateToUrl(item.url)}
                  style={{
                    background: "#fff", borderRadius: 16, padding: 20, border: "1px solid #e9ecef",
                    transition: "all .2s", cursor: item.url ? "pointer" : "default"
                  }}
                >
                  {item.image && (
                    <div style={{
                      width: "100%", height: 160, borderRadius: 12, marginBottom: 16,
                      backgroundImage: `url(${imageMap[item.image] || placeholder_image})`,
                      backgroundSize: "cover", backgroundPosition: "center"
                    }} />
                  )}
                  <h4 style={{ margin: "0 0 8px", fontSize: 18, fontWeight: 600, color: "#2c3e50" }}>
                    {item.title || item.label || item.name}
                  </h4>
                  {item.description && (
                    <p style={{
                      margin: 0, fontSize: 14, color: "#6c757d", lineHeight: 1.5,
                      display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden"
                    }}>
                      {item.description}
                    </p>
                  )}
                </div>
              ))}
            </div>
          )}

          {isRankType && (
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))", gap: 24 }}>
              {resolved.content.map((item, idx) => (
                <div key={idx} style={{
                  background: "#fff", borderRadius: 16, padding: 24, border: "1px solid #e9ecef",
                  transition: "all .2s"
                }}>
                  <div style={{ display: "flex", alignItems: "center", marginBottom: 16 }}>
                    <div style={{
                      width: 40, height: 40, borderRadius: "50%",
                      background: idx < 3 ? "#ffd700" : "#e9ecef",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      marginRight: 16, fontSize: 18, fontWeight: "bold", color: idx < 3 ? "#fff" : "#6c757d"
                    }}>
                      {idx + 1}
                    </div>
                    {item.image && (
                      <div style={{
                        width: 60, height: 60, borderRadius: 8,
                        backgroundImage: `url(${imageMap[item.image] || placeholder_image})`,
                        backgroundSize: "cover", backgroundPosition: "center"
                      }} />
                    )}
                  </div>
                  <h4 style={{ margin: "0 0 8px", fontSize: 18, fontWeight: 600, color: "#2c3e50" }}>
                    {item.title || item.label || item.name}
                  </h4>
                  {item.description && (
                    <p style={{ margin: 0, fontSize: 14, color: "#6c757d", lineHeight: 1.5 }}>
                      {item.description}
                    </p>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }

  // MOBILE: delegate to carousels
  return (
    <div>
      <div className="store-menu-section-div" style={{ margin: "0px 0px 0px 0px" }}/>
      <div className="store-menu-topic-filled-carousel-col">
        <div style={{ paddingLeft: 20 }}>
          <p className="mb-0 store-menu-section-title">{column.label}</p>
          {column.description && <p className="mb-0 store-menu-section-subtitle">{column.description}</p>}
        </div>

        {isGridType && (
          <CardCarousel
            cards={resolved.content}
            type={column.type}
            imageMap={imageMap}
            navigateToUrl={navigateToUrl}
          />
        )}
        {isRankType && (
          <RankedCarousel
            cards={resolved.content}
            type={column.type}
            imageMap={imageMap}
            navigateToUrl={navigateToUrl}
          />
        )}
      </div>
    </div>
  );
};

export default SectionList;
